import React from "react";
import { Link } from "react-router-dom";
import { CodexLockup } from "@/components/brand/CodexLockup";

export function Footer() {
  return (
    <footer className="mt-24 border-t border-white/5">
      <div className="mx-auto w-full max-w-[1200px] px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col items-center gap-8 text-center md:flex-row md:items-start md:justify-between md:gap-6 md:text-left">
          <div className="flex max-w-md flex-col items-center md:items-start">
            <CodexLockup vertical iconSize={48} showSubtitle wordmarkSize="text-2xl" />
            <p className="mt-4 text-sm leading-6 text-muted-foreground">
              An archive of history, science, archaeology, Scripture, and the unexplained — built on
              intellectual honesty, clear sourcing, and evidence clearly separated from interpretation.
            </p>
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.22em] text-gold-soft/80">
              Discover. Discern. Decide.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-x-12 gap-y-2 text-sm">
            <div className="flex flex-col items-center gap-2 md:items-start">
              <span className="codex-meta-label">Explore</span>
              <Link to="/explore" className="text-muted-foreground hover:text-gold-light transition-colors">Case Files</Link>
              <Link to="/timelines" className="text-muted-foreground hover:text-gold-light transition-colors">Timeline</Link>
              <Link to="/maps" className="text-muted-foreground hover:text-gold-light transition-colors">Atlas</Link>
              <Link to="/universe" className="text-muted-foreground hover:text-gold-light transition-colors">Knowledge Universe</Link>
              <Link to="/archivist" className="text-muted-foreground hover:text-gold-light transition-colors">The Archivist</Link>
            </div>
            <div className="flex flex-col items-center gap-2 md:items-start">
              <span className="codex-meta-label">Account</span>
              <Link to="/dashboard" className="text-muted-foreground hover:text-gold-light transition-colors">My Research</Link>
              <Link to="/login" className="text-muted-foreground hover:text-gold-light transition-colors">Sign in</Link>
            </div>
          </div>
        </div>
        <div className="mt-10 text-center font-mono text-[11px] leading-5 tracking-[0.06em] text-muted-foreground/60 break-words">
          © {new Date().getFullYear()} CODEX — Archive of the Unexplained. A place to think, not to be told what to believe.
        </div>
        {/* Creator's mark — discreet, secondary to the CODEX brand above */}
        <div
          data-testid="uncle-dave-creator-mark"
          className="mt-7 flex flex-col items-center gap-2 pb-2 text-center"
        >
          <img
            src="/images/brand/uncle-dave-glasses-gold.png"
            alt="Uncle Dave creator mark"
            className="h-auto w-8 select-none opacity-80 sm:w-9"
            draggable={false}
          />
          <p className="font-mono text-[11px] leading-5 tracking-[0.08em] text-muted-foreground/55">
            Recovered from the curious mind of{" "}
            <span className="text-gold-soft/90">Uncle Dave</span>.
          </p>
        </div>
      </div>
    </footer>
  );
}
